import React, { useEffect, useRef } from 'react'
import { Animated } from 'react-native'

export function PulseDot({ color }: { color: string }) {
  const opacity = useRef(new Animated.Value(1)).current

  useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(opacity, { toValue: 0.35, duration: 500, useNativeDriver: true }),
        Animated.timing(opacity, { toValue: 1, duration: 500, useNativeDriver: true }),
      ])
    ).start()
  }, [opacity])

  return <Animated.View style={{ width: 6, height: 6, borderRadius: 999, backgroundColor: color, opacity }} />
}
